import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CallService } from '../../core/call-service/browser/call.service';
import { LogService } from '../../core/log/log.service';
import { getProvincesUrl } from '../../core/router/routes-provider';
import { Province } from './province.model';

@Injectable({ providedIn: 'root' })
export class ProvinceService {
	constructor(private callService: CallService, private logService: LogService) {}

	loadProvince(): Observable<Province[]> {
		const urltoCall = getProvincesUrl();
		this.logService.info('Calling ', urltoCall);
		const result = this.callService.CallApiList<Province>('GET', urltoCall);
		return result;
	}
}
